import { QueryResult, useQuery, OperationVariables, ApolloError } from '@apollo/client';
import { Classroom, StoreTypename } from 'types';
import GET_CLASSROOM from '../../queries/classrooms/get-classroom-query';

export type ClassroomStoreState = {
  data?: Classroom;
  isLoading: boolean;
  error: ApolloError | undefined;
};

export type ClassroomStoreDispatch = {
  classroomRefetch: any;
};

export type ClassroomStore = [ClassroomStoreState, ClassroomStoreDispatch];

export const getDefaultClassroomStoreState = (): any => ({
  __typename: StoreTypename.USER_CLASSROOM,
});

const useClassroomStore = (id: number): ClassroomStore => {
  const {
    data,
    loading,
    error,
    refetch: classroomRefetch,
  }: QueryResult<{ classroom: Classroom }> = useQuery(GET_CLASSROOM, {
    variables: {
      classroomWhere: {
        id: id,
      },
    } as OperationVariables,
  });

  return [
    {
      ...(data && { data: { ...data.classroom } }),
      isLoading: loading,
      error,
    },
    {
      classroomRefetch,
    },
  ];
};

export default useClassroomStore;
